import { useEffect, useState, useRef } from "react";

function StudentMessages() {
  const user = JSON.parse(localStorage.getItem("user"));

  const [messages, setMessages] = useState([]);
  const [text, setText] = useState("");

  const chatEndRef = useRef(null);

  // ADMIN USER ID
  const adminId = 13;

  const fetchChat = async () => {
    if (!user?.user_id) return;

    try {
      const res = await fetch(
        `https://www.gurukrupaeducation.com/api/get-messages.php?sender_id=${user.user_id}&receiver_id=${adminId}&sender_role=student&receiver_role=admin`
      );

      const data = await res.json();
      setMessages(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error fetching chat:", error);
    }
  };

  useEffect(() => {
    fetchChat();

    const interval = setInterval(fetchChat, 2000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({
      behavior: "smooth",
    });
  }, [messages]);

  const sendMessage = async () => {
    if (!text.trim() || !user?.user_id) return;

    try {
      const res = await fetch("https://www.gurukrupaeducation.com/api/send-message.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          sender_id: user.user_id,
          receiver_id: adminId,
          sender_role: "student",
          receiver_role: "admin",
          message: text.trim(),
        }),
      });

      const data = await res.json();

      if (data.success) {
        setText("");
        fetchChat();
      } else {
        console.error(data.error || "Message send failed");
      }
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          padding: 15,
          borderBottom: "1px solid #eee",
          fontWeight: "bold",
        }}
      >
        Chat with Admin
      </div>

      <div
        style={{
          flex: 1,
          padding: 20,
          overflowY: "auto",
          background: "#fafafa",
        }}
      >
        {messages.map((m) => (
          <div
            key={m.id}
            style={{
              display: "flex",
              justifyContent: m.sender_role === "admin" ? "flex-start" : "flex-end",
              marginBottom: 10,
            }}
          >
            <div
              style={{
                maxWidth: "70%",
                padding: "10px 15px",
                borderRadius: "20px",
                background: m.sender_role === "admin" ? "#e4e6eb" : "#0095f6",
                color: m.sender_role === "admin" ? "#000" : "#fff",
                wordBreak: "break-word",
              }}
            >
              {m.message}
            </div>
          </div>
        ))}

        <div ref={chatEndRef}></div>
      </div>

      <div
        style={{
          padding: 10,
          borderTop: "1px solid #eee",
          display: "flex",
        }}
      >
        <input
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Message..."
          style={{
            flex: 1,
            padding: 10,
            borderRadius: 20,
            border: "1px solid #ccc",
            outline: "none",
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              sendMessage();
            }
          }}
        />

        <button
          onClick={sendMessage}
          style={{
            marginLeft: 10,
            background: "#0095f6",
            color: "#fff",
            border: "none",
            padding: "10px 15px",
            borderRadius: "20px",
            cursor: "pointer",
          }}
        >
          Send
        </button>
      </div>
    </div>
  );
}

export default StudentMessages;
